// @flow
/** @jsx jsx */

import _ from 'lodash';

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import Link from 'app/common/components/Link';

const Styles = {
  root: isRow =>
    isRow
      ? {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderTop: `1px solid ${Colors.adamantium}`,
          marginTop: '4em',
          paddingTop: '2em',
          '@media (max-width: 640px)': {
            flexDirection: 'column',
          },
        }
      : {
          marginTop: '2em',
        },
  item: isRow =>
    isRow && {
      width: '30%',
      margin: '1em 2em',
      alignSelf: 'baseline',
      '@media (max-width: 640px)': {
        width: '100%',
      },
    },
  sectionHeading: {
    color: Colors.batmobile,
    fontSize: '1em',
    fontWeight: '600',
    padding: '0',
  },
  sectionContent: {
    margin: '15px 0',
  },
  sectionLink: {
    margin: '15px 0',
    color: Colors.heroine,
    transition: 'all 0.1s ease',
  },
};

const RequestAddUpdateItem = ({
  heading,
  content,
  link,
  className,
}: {
  className?: string,
  content: string,
  heading: string,
  link: {| href: string, text: string |},
}) => (
  <div className={className}>
    <h3 css={Styles.sectionHeading}>{heading}</h3>
    <p className="small" css={Styles.sectionContent}>
      {content}
    </p>
    <p className="small" css={Styles.sectionContent}>
      <Link css={Styles.sectionLink} href={link.href} rel="nofollow">
        {link.text}
      </Link>
    </p>
  </div>
);

const RequestAddUpdates = ({
  request,
  add,
  updates,
  isZapbookPage,
  isCategoryPage,
}: {
  request: { [string]: string | { [string]: string } },
  add: { [string]: string | { [string]: string } },
  updates: { [string]: string | { [string]: string } },
  isZapbookPage: boolean,
  isCategoryPage: boolean,
}) => {
  const isRow = !isZapbookPage && !isCategoryPage;
  return (
    <div css={Styles.root(isRow)}>
      {_.map([request, add, updates], (section, iSection) => (
        <RequestAddUpdateItem
          css={Styles.item(isRow)}
          key={iSection}
          {...section}
        />
      ))}
    </div>
  );
};

export default RequestAddUpdates;
